import React, { useState, useEffect } from "react";
import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Card,
    CardContent,
    Box,
    Avatar,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import LoginDialog from "./components/Signin";
import { logout_url } from "./api_registry";

import {
    Description,
    VideoLibrary,
    People,
    Assignment,
    Search,
    AccountCircle,
    Stars,
    Logout,
} from "@mui/icons-material";
// import mapGeoidLogo from "./logo.png";

const NeonNetworkBackground = () => {
    useEffect(() => {
        const canvas = document.getElementById("neon-bg");
        const ctx = canvas.getContext("2d");

        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        const nodes = [];
        const total = 35;

        for (let i = 0; i < total; i++) {
            nodes.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                vx: (Math.random() - 0.5) * 3,
                vy: (Math.random() - 0.5) * 3,
            });
        }

        function draw() {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // neon grid
            ctx.strokeStyle = "rgba(255, 255, 255, 0.35)";
            ctx.lineWidth = 1;

            // lines between nodes
            nodes.forEach((n1, i) => {
                nodes.forEach((n2, j) => {
                    if (i !== j) {
                        const dist = Math.sqrt(
                            (n1.x - n2.x) ** 2 + (n1.y - n2.y) ** 2
                        );
                        if (dist < 180) {
                            ctx.globalAlpha = 1 - dist / 180;
                            ctx.beginPath();
                            ctx.moveTo(n1.x, n1.y);
                            ctx.lineTo(n2.x, n2.y);
                            ctx.stroke();
                        }
                    }
                });
            });

            ctx.globalAlpha = 1;

            // neon dots
            nodes.forEach((n) => {
                ctx.beginPath();
                ctx.fillStyle = "#ffffff";
                ctx.shadowColor = "#ffffff";
                ctx.shadowBlur = 12;
                ctx.arc(n.x, n.y, 3, 0, Math.PI * 2);
                ctx.fill();

                n.x += n.vx;
                n.y += n.vy;

                if (n.x < 0 || n.x > canvas.width) n.vx *= -1;
                if (n.y < 0 || n.y > canvas.height) n.vy *= -1;
            });

            requestAnimationFrame(draw);
        }

        draw();
    }, []);

    return (
        <canvas
            id="neon-bg"
            style={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                zIndex: 0,
            }}
        />
    );
};

const LandingPage = ({user_state}) => {
    const [particles, setParticles] = useState([]);
    const [loginOpen, setLoginOpen] = useState(false);
    const [user, setUser] = user_state;
    const navigate = useNavigate();

    // called when user clicks logout icon
    const handleLogout = async () => {
        try {
            await fetch(logout_url, {
                method: "POST",
                credentials: "include",
                mode: "cors",
                headers: {
                    Accept: "application/json",
                },
            });
        } catch (err) {
            console.warn("logout request failed", err);
            // proceed to clear state anyway
        }

        // clear all stored state and redirect to landing
        setUser({});
        localStorage.clear();
        navigate("/");
    };

    useEffect(() => {
        const newParticles = Array.from({ length: 50 }, (_, i) => ({
            id: i,
            x: Math.random() * 100,
            y: Math.random() * 100,
            size: Math.random() * 4 + 2,
            duration: Math.random() * 3 + 2,
            delay: Math.random() * 2,
        }));
        setParticles(newParticles);
    }, []);

    const features = [
        {
            icon: <Description sx={{ fontSize: 40 }} />,
            title: "Projects",
            description: "Lorem ipsum dolor sit meuiscut In-Management",
            link: "/projects",
        },
        {
            icon: <VideoLibrary sx={{ fontSize: 40 }} />,
            title: "Route Videos",
            description:
                "Lorem ipsum dolor sit mex incmdor apsei Map iaus menrismat",
            link: "/route-video",
        },
        {
            icon: <People sx={{ fontSize: 40 }} />,
            title: "User Management",
            description: "Lorem ipsum dolor sit mair onis-foanney ma euismat",
            link: "/user-management",
            // link : "http://13.201.17.67/"
        },
        {
            icon: <Assignment sx={{ fontSize: 40 }} />,
            title: "Survey Management",
            description: "Lorem ipsum dolor sit ment omed tivcl eget",
            link: "/survey-tickets",
        },
    ];

    const FeatureCard = ({ icon, title, description, link }) => {
        const [isHovered, setIsHovered] = useState(false);
        const navigate = useNavigate();

        return (
            <Card
                onClick={() => navigate(link)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                sx={{
                    background: isHovered
                        ? "rgba(255, 255, 255, 1)"
                        : "rgba(255, 255, 255, 0.95)",
                    backdropFilter: "blur(20px)",
                    borderRadius: "1rem",
                    padding: "1.5rem",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    textAlign: "center",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                    transform: isHovered ? "scale(1.05)" : "scale(1)",
                    boxShadow: isHovered
                        ? "0 20px 60px rgba(0, 0, 0, 0.3)"
                        : "0 4px 12px rgba(0, 0, 0, 0.1)",
                }}
                elevation={0}
            >
                <CardContent sx={{ padding: 0 }}>
                    <Box
                        sx={{
                            width: "60px",
                            height: "60px",
                            margin: "0 auto 1rem",
                            background:
                                "linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            transition: "all 0.3s",
                            transform: isHovered ? "scale(1.1)" : "scale(1)",
                        }}
                    >
                        {icon}
                    </Box>

                    <Typography
                        variant="h6"
                        sx={{
                            fontSize: "1.1rem",
                            fontWeight: "bold",
                            color: "#1e293b",
                            marginBottom: "0.5rem",
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: "0.8rem",
                            color: "#64748b",
                            lineHeight: "1.5",
                        }}
                    >
                        {description}
                    </Typography>
                </CardContent>
            </Card>
        );
    };

    return (
        <>
            <style>
                {`
          @keyframes float {
            0%, 100% { 
              transform: translateY(0px) translateX(0px); 
              opacity: 0.3; 
            }
            50% { 
              transform: translateY(-20px) translateX(10px); 
              opacity: 0.8; 
            }
          }
          @keyframes pulse {
            0%, 100% { opacity: 0.3; }
            50% { opacity: 0.6; }
          }
        `}
            </style>

            <Box
                sx={{
                    position: "relative",
                    height: "100vh",
                    width: "100%",
                    overflow: "hidden",
                    backgroundColor: "#0d293cff",
                    fontFamily:
                        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                }}
            >
                {/* Background */}
                <NeonNetworkBackground />

                {/* Header */}
                <AppBar
                    position="relative"
                    elevation={0}
                    sx={{
                        zIndex: 100,
                        background: "rgba(0, 0, 0, 0.6)",
                        backdropFilter: "blur(10px)",
                    }}
                >
                    <Toolbar
                        sx={{
                            justifyContent: "space-between",
                            padding: "0.01rem 2rem",
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.75rem",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: "1.4rem",
                                    fontWeight: 700,
                                    letterSpacing: "0.08em",
                                    background:
                                        "linear-gradient(90deg, #e6c673ff, #6bbff3ff)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    userSelect: "none",
                                }}
                            >
                                MapGeoid | Nexus
                            </Typography>
                        </Box>

                        <Box sx={{ display: "flex", gap: "1rem" }}>
                            <IconButton
                                sx={{
                                    width: "40px",
                                    height: "40px",
                                    background: "transparent",
                                    borderRadius: "8px",
                                    transition: "background 0.3s",
                                    fontSize: "1.2rem",
                                    color: "white",
                                    "&:hover": {
                                        background: "rgba(255,255,255,0.1)",
                                    },
                                }}
                            >
                                <Search />
                            </IconButton>

                            {/* show account name or login button depending on user */}
                            {user?.name ? (
                                <>
                                    <IconButton
                                        onClick={handleLogout}
                                        sx={{
                                            width: "40px",
                                            height: "40px",
                                            background: "transparent",
                                            borderRadius: "8px",
                                            transition: "background 0.3s",
                                            color: "white",
                                            "&:hover": {
                                                background: "rgba(255,255,255,0.1)",
                                            },
                                        }}
                                        title="Logout"
                                    >
                                        <Logout />
                                    </IconButton>

                                    <IconButton
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 0.8,
                                            padding: "6px 10px",
                                            background: "transparent",
                                            borderRadius: "8px",
                                            transition: "background 0.3s",
                                            color: "white",
                                            "&:hover": {
                                                background: "rgba(255,255,255,0.1)",
                                            },
                                        }}
                                    >
                                        <AccountCircle fontSize="medium" />

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 500,
                                                color: "white",
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {user?.name}
                                        </Typography>
                                    </IconButton>
                                </>
                            ) : (
                                <IconButton
                                    onClick={() => setLoginOpen(true)}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 0.8,
                                        padding: "6px 10px",
                                        background: "transparent",
                                        borderRadius: "8px",
                                        transition: "background 0.3s",
                                        color: "white",
                                        "&:hover": {
                                            background: "rgba(255,255,255,0.1)",
                                        },
                                    }}
                                >
                                    <AccountCircle fontSize="medium" />

                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 500,
                                            color: "white",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Login
                                    </Typography>
                                </IconButton>
                            )}

                            <LoginDialog
                                open={loginOpen}
                                onClose={() => setLoginOpen(false)}
                                onLoginSuccess={(data) => {
                                    console.log(data);
                                    setUser(data);
                                }}
                            />
                        </Box>
                    </Toolbar>
                </AppBar>

                {/* Hero Section */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 10,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "2rem 2rem",
                        height: "calc(100vh - 140px)",
                        overflow: "hidden",
                    }}
                >
                    <Box sx={{ textAlign: "center", marginBottom: "1.5rem" }}>
                        <Typography
                            component="h1"
                            sx={{
                                fontSize: "3.5rem",
                                fontWeight: "bold",
                                color: "white",
                                letterSpacing: "-0.02em",
                                marginBottom: "0.5rem",
                                margin: 0,
                            }}
                        >
                            MAPGEOID SURVEY
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: "1.1rem",
                                color: "rgba(255, 255, 255, 0.8)",
                                fontWeight: "300",
                                margin: 0,
                            }}
                        >
                            Smart Routing for Next-Gen Networks
                        </Typography>
                    </Box>

                    {/* Feature Cards */}
                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(4, 1fr)",
                            gap: "1.5rem",
                            maxWidth: "1200px",
                            width: "100%",
                        }}
                    >
                        {features.map((feature, index) => (
                            <FeatureCard key={index} {...feature} />
                        ))}
                    </Box>
                </Box>

                {/* Footer */}
                <Box
                    component="footer"
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 100,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "1rem 2rem",
                        backdropFilter: "blur(10px)",
                        background: "rgba(0, 0, 0, 0.6)",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            color: "rgba(255, 255, 255, 0.7)",
                            fontSize: "0.875rem",
                        }}
                    >
                        <Typography variant="body2">Developed by:</Typography>
                        <Box
                            component="img"
                            src={"logo.png"}
                            sx={{
                                width: "40px",
                                height: "40px",
                                // borderRadius: "4px",
                                objectFit: "contain",
                            }}
                        />
                        <Typography
                            variant="body2"
                            sx={{ fontWeight: "600", color: "white" }}
                        >
                            MapGeoid
                        </Typography>
                    </Box>
                    {/* <IconButton
            sx={{
              fontSize: "2rem",
              color: "white",
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.2)",
              },
            }}
          >
            <Stars />
          </IconButton> */}
                </Box>
            </Box>
        </>
    );
};

export default LandingPage;
